import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import "./IncomingOffers.scss";
import OffersSummary from "../../components/Offer/OffersSummary";
import offerStore from "../../stores/OfferStore";
import useTranslation from "../../hooks/useTranslation";

const IncomingOffers = observer(() => {
  const { t } = useTranslation();

  useEffect(() => {
    offerStore.fetchUserOffers();
  }, []);

  return (
    <div className="offersContainer container">
      <h2>{t("incoming-offers")}</h2>
      <OffersSummary rawOffers={offerStore.userOffers} incomingOffer={true} />
    </div>
  );
});

export default IncomingOffers;
